{
    "coordinates": [
        -30.049164968711125,
        27.278132421292298
    ],
    "tooltip": "Elliot",
    "title": "Ellito Formatioon",
    "country": "South Africa & Lesotho",
    "period": "Jurassic",
    "alt": "TODO"
}
